module.exports = __webpack_public_path__ + "img/2.88d8728b.svg";